module.exports = __webpack_public_path__ + "img/asm.16f433a6.svg";